import React from "react";
import { Modal } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import { closeModal } from "../../app/common/modals/modalReducer";
import LeaveTrackForm from "../staff/LeaveList/LeaveTrackForm";

export default function LeaveTrackModal(props) {
    const dispatch = useDispatch();
    let profile = props.profile;
    let profileClient = props.profileClient;
    let type = props.type;
    let company = props.company;
    return (
        <Modal size="large" open={true} onClose={() => dispatch(closeModal())} closeOnDimmerClick={false} trigger={<Button>Show Modal</Button>} closeIcon>
            <Modal.Header>&nbsp;</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div className="content_top">
                        <img className="img_header" src="/assets/your_documents.png" alt="Your Documents" />

                        <h2 className="ui center aligned header">DRG Leave Request Form</h2>
                        <p>Submit staff members dates and documents.</p>
                    </div>

                    <Divider />

                    <LeaveTrackForm profile={profile} profileClient={profileClient} type={type} company={company} />
                </Modal.Description>
            </Modal.Content>
        </Modal>
    );
}
